// ResponseEnum.js
export const ResponseEnum = Object.freeze({
    RESET: 'RESET',
    NOT_SURE: 'NOT SURE',
    YES: 'YES',
    NO: 'NO',
});
